import FeatureCardContent from '@/design-system/Molecules/FeatureCardContent';

interface FeatureCardProps {
    title: string;
    description: string;
    link: string;
    image: string;
    backgroundClass?: string;
}

const FeatureCard = ({
    title,
    description,
    link,
    image,
    backgroundClass = 'bg-gray-100',
}: FeatureCardProps) => (
    <div
        className={`flex-1 rounded-2xl relative overflow-hidden ${backgroundClass} h-[30rem] lg:h-[47rem] xl:h-[30rem]`}
    >
        <div className="grid grid-cols-1 xl:grid-cols-2 h-full">
            <div className="py-[4.5em] pr-[1em] pl-[2.25em] flex flex-col justify-center">
                <FeatureCardContent
                    title={title}
                    description={description}
                    link={link}
                />
            </div>
            <div className="relative flex items-end justify-end">
                <img
                    src={image}
                    alt={title}
                    className="h-full w-auto object-contain object-bottom max-h-[350px]"
                />
            </div>
        </div>
    </div>
);

export default FeatureCard;